/** Convert image src (http/blob/data) to a compressed data URL for PDF payloads. */
export async function toPdfDataUrl(src, { maxEdge = 960, quality = 0.82 } = {}) {
  if (!src || typeof src !== 'string') return null;
  const trimmed = src.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('data:image/')) return trimmed;

  const img = await new Promise((resolve, reject) => {
    const el = new Image();
    el.crossOrigin = 'anonymous';
    el.onload = () => resolve(el);
    el.onerror = () => reject(new Error('Failed to load image for PDF'));
    el.src = trimmed;
  });

  const w = img.naturalWidth || img.width || 1;
  const h = img.naturalHeight || img.height || 1;
  const scale = Math.min(1, maxEdge / Math.max(w, h));
  const cw = Math.max(1, Math.round(w * scale));
  const ch = Math.max(1, Math.round(h * scale));
  const canvas = document.createElement('canvas');
  canvas.width = cw;
  canvas.height = ch;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, cw, ch);
  return canvas.toDataURL('image/jpeg', quality);
}

export async function mapProductImagesToDataUrls(products, limit = 8) {
  if (!Array.isArray(products)) return [];
  const out = [];
  for (const p of products.slice(0, limit)) {
    const src = p?.image_url || p?.imageUrl || p?.thumbnail_url || null;
    let dataUrl = null;
    try {
      dataUrl = await toPdfDataUrl(src, { maxEdge: 320, quality: 0.8 });
    } catch {
      dataUrl = null;
    }
    out.push({
      ...p,
      image_url: dataUrl || src || null,
    });
  }
  return out;
}
